// extracted by mini-css-extract-plugin
export default {"blue":"style_blue__dPV3K","grey":"style_grey__GUnLR","orange":"style_orange__Gh1cK","icon":"style_icon__1wJUS","text":"style_text__sUobx"};